import React, { useCallback, useEffect, useState } from 'react'
import Toast, { showToast } from '../../Components/Toast';
import Header from './Header';
import Add from './Add';
import Edit from './Edit';
import Loader from '../../Components/Loader';
import Table from '../../Components/Table';
import { EuiButton, EuiImage, EuiPageBody } from '@elastic/eui';
import axios from '../../axiosService';
import ConfirmModel, { showDialog, hideDialog } from '../../Components/ConfirmModel'
import { useNavigate } from 'react-router-dom';

function Articles() {
  const server = process.env.REACT_APP_APIPATH
  const authtoken = localStorage.getItem("authtoken");
  const config = {
    headers: {
      'Authorization': "Bearer " + authtoken
    }
  }
  const navigate = useNavigate();
  const [isAdding, setIsAdding] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isPageEditing, setIsPageEditing] = useState(false);
  const [EditData, setEditData] = useState({});

  const [IsLoading, setIsLoading] = useState(false)
  const startLoading = useCallback(() => {
    setIsLoading(true);
  }, []);

  const stopLoading = useCallback(() => {
    setIsLoading(false);
  }, []);

  const [Data, setData] = useState([])

  const columns = [
    { field: 'rowNumber', name: 'Row Number', sortable: true },
    { field: 'causeName', name: 'Cause Name', sortable: true },
    {
      field: 'photo', name: 'Photo', render: (Photo) => (
        <EuiImage size="m" src={server + Photo} alt='No Image Found' allowFullScreen hasShadow />
      )
    },
    {
      field: 'causeID', name: 'Edit Page', render: (causeID) => (
        <EuiButton onClick={()=>{setIsPageEditing(true);navigate(causeID+"/page")}}>Edit Page</EuiButton>
      )
    },
  ]

  // delete function
  const deleteRecord = async (record) => {
    startLoading();

    try {
      const response = await axios.delete(`${server}api/Cause/${record.causeID}`, config);
      if (response.status === 200) {
        filldata()
        showToast("Record Deleted", "success", 2000);
      }
      stopLoading();
      hideDialog();
    } catch (error) {
      showToast(error.toString(), "error", 15000);
      stopLoading();
    }
  };

  // edit function
  const editRecord = async (record) => {
    try {
      startLoading();
      const response = await axios.get(`${server}api/Cause/${record.causeID}`, config)
      if (response.status === 200) {
        const data = await response.data;
        setEditData(data);
        setIsEditing(true);
      }
      stopLoading();
    } catch (error) {
      showToast(error.toString(), "error", 15000);
      console.error(error);
      stopLoading();
    }
  };

  //declare edit and delete buttons
  const actions = [
    {
      name: 'Edit',
      isPrimary: true,
      description: 'Edit this Record',
      icon: 'pencil',
      type: 'icon',
      onClick: editRecord,
      'data-test-subj': 'action-edit',
    }, {
      name: "Delete",
      description: 'Delete this Record',
      icon: 'trash',
      color: 'danger',
      type: 'icon',
      onClick: showDialog,
      isPrimary: true,
      'data-test-subj': 'action-delete',
    }
  ];

  //add buttons to columns
  const columnsWithActions = [
    ...columns,
    {
      name: 'Actions',
      actions,
    },
  ];

  //get table data
  const filldata = async () => {
    startLoading();
    try {
      const response = await axios.get(`${server}api/Cause`, config);
      if (response.status === 200) {
        const data = await response.data;
        setData(data);
      }
      stopLoading();
    } catch (error) {
      showToast(error.toString(), "error", 15000);
      stopLoading();
    }
  }

  useEffect(() => {
    filldata();
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (!isEditing && !isAdding) {
      filldata()
    }
    // eslint-disable-next-line
  }, [isAdding, isEditing]);

  useEffect(() => {
    if (!isEditing) {
      setEditData({});
    }
  }, [isEditing]);

  return (
    <EuiPageBody style={{ width: "100%", padding: "10px" }}>
      <Loader IsLoading={IsLoading} />
      {!isAdding && !isEditing && !isPageEditing && (
        <>
          <Header
            headerText="Cause Master"
            setIsAdding={setIsAdding}
          />
          <Table data={Data} columns={columnsWithActions} height={70} />
        </>
      )}
      {isAdding && (
        <Add
          server={server}
          authtoken={authtoken}
          startLoading={startLoading}
          stopLoading={stopLoading}
          setIsAdding={setIsAdding}
        />
      )}
      {isEditing && (
        <Edit
          server={server}
          authtoken={authtoken}
          EditData={EditData}
          startLoading={startLoading}
          stopLoading={stopLoading}
          setIsEditing={setIsEditing}
        />
      )}
      <Toast />
      <ConfirmModel title="Delete Record ?" text="The Record will be Deleted. Please Proceed With Caution !" confirmButton="Delete" cancelButton="Cancel" confirmFunction={deleteRecord} />
    </EuiPageBody>
  )
}

export default Articles
